import { DateValue } from '@internationalized/date';
import {
  CreatePaymentInput,
  MoneyInput,
  PaymentMethod,
  PaymentType,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';
import { anyDateToISOString } from '~/shared/utils/dateTime';

export type PaymentCreateParams = {
  paymentType: PaymentType;
  paymentMethod: PaymentMethod;
  documentNumber?: string;
  amount: MoneyInput;
  transactionDate: DateValue;
  accountId?: string | null;
  financialAccountId: string;
  checkFacilityId?: string | null;
  checkNumber?: string | null;
  checkMemo?: string | null;
  achNumber?: string | null;
  wireNumber?: string | null;
};

export const paymentCreateAtom = createMutationAtomFactory(
  'finance.paymentCreate',
  (params: PaymentCreateParams) => {
    const input: CreatePaymentInput = {
      paymentType: params.paymentType,
      paymentMethod: params.paymentMethod,
      amount: params.amount,
      financialAccountId: params.financialAccountId,
      transactionDate: anyDateToISOString(params.transactionDate) ?? '',
    };

    if (params.documentNumber) {
      input.documentNumber = params.documentNumber;
    }
    if (params.accountId) {
      input.accountId = params.accountId;
    }
    if (params.checkFacilityId) {
      input.checkFacilityId = params.checkFacilityId;
    }
    if (params.checkNumber) {
      input.checkNumber = params.checkNumber;
    }
    if (params.checkMemo) {
      input.checkMemo = params.checkMemo;
    }
    if (params.achNumber) {
      input.achNumber = params.achNumber;
    }
    if (params.wireNumber) {
      input.wireNumber = params.wireNumber;
    }

    return {
      financePaymentCreate: {
        __args: {
          input,
        },
        id: true,
        documentNumber: true,
        paymentType: true,
        paymentMethod: true,
        status: true,
        amount: {
          amount: true,
          currencyCode: true,
        },
        transactionDate: true,
        wireNumber: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
